import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioBodyFn = /* @__PURE__ */ createRecipe('radio-body', {}, [])

const radioBodyVariantMap = {}

const radioBodyVariantKeys = Object.keys(radioBodyVariantMap)

export const radioBody = /* @__PURE__ */ Object.assign(memo(radioBodyFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioBody',
  __getCompoundVariantCss__: radioBodyFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioBodyVariantKeys,
  variantMap: radioBodyVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioBodyVariantKeys)
  },
  getVariantProps: radioBodyFn.getVariantProps,
})